import { render, staticRenderFns } from "./CompraTrae.vue?vue&type=template&id=37369878&scoped=true&"
import script from "./CompraTrae.vue?vue&type=script&lang=js&"
export * from "./CompraTrae.vue?vue&type=script&lang=js&"
import style0 from "./CompraTrae.vue?vue&type=style&index=0&id=37369878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37369878",
  null
  
)

export default component.exports